import { getGoogleSheets } from './googleSheetsApi';
import DateUtils from './DateUtils';

export class Model {
	dates;
	currentDate;

	static initForm = () => {
		(function () {
			emailjs.init({
				publicKey: 'WDbrRG7RHZmUHMFuo',
			});
		})();
	};

	static getCurrDate = () => this.currentDate;

	static sendForm = async form => {
		try {
			await emailjs.sendForm('service_no5cdcq', 'template_z9fsh63', form);
		} catch (error) {
			throw new Error(error.message);
		}
	};
	static getCalendarData = async id => {
		try {
			const data = await Promise.race([
				getGoogleSheets(id),
				this._waitForData(60),
			]);

			this.data = data;
			this.currentDate = new Date(data.currentDate);

			return {
				getDaysData: this.getDays,
				currDate: this.currentDate,
				min: this.currentDate,
				max: this.data.maxDate,
			};
		} catch (err) {
			throw new Error(err.message);
		}
	};

	static _waitForData = async time => {
		const timeoutPromise = new Promise((_, reject) => {
			setTimeout(() => {
				reject(new Error('Fetching data timed out'));
			}, time * 1000);
		});
		return timeoutPromise;
	};

	static _getOccupiedDays = (year, month) => {
		const days = this.data.dates
			.map(date => new Date(date))
			.filter(date => DateUtils.isSameMonth(date, DateUtils.from(year, month)));
		return days;
	};

	static getDays = (year, month) => {
		const occupiedDays = this._getOccupiedDays(year, month);
		const daysInMonth = DateUtils.daysInMonth(year, month);
		const occupiedDaysSet = new Set(
			occupiedDays ? occupiedDays.map(day => day.getDate()) : []
		);

		let days = [];
		for (let i = 1; i <= daysInMonth; i++) {
			const date = DateUtils.from(year, month, i);
			let isOccupied = occupiedDaysSet.has(i);
			const {
				year: currYear,
				month: currMonth,
				day: currDay,
			} = DateUtils.object(this.currentDate);
			const yesterday = DateUtils.from(currYear, currMonth, currDay);
			if (date < yesterday) isOccupied = true;
			days.push({ date, occupied: isOccupied });
		}
		return days;
	};
}
